"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- SELECTABLELIST : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'SelectableList',
  group: _definitionhelpers.groupNames.lists,
  props: {
    name: {
      type: 'string'
    },
    type: {
      type: 'string',
      default: 'checkbox',
      options: ['checkbox', 'fancyradio', 'radio']
    },
    klass: {
      type: 'string'
    },
    items: {
      type: 'object',
      default: [{
        value: 'PAYPAL',
        text: 'Paypal'
      }, {
        value: 'CHECKS',
        text: 'Check (US Only)'
      }, {
        value: 'ACH',
        text: 'Direct Deposit / ACH (US only)'
      }, {
        value: 'WIRE',
        text: 'Wire Transfer (international payment method)'
      }]
    },
    selected: {
      type: 'object',
      default: ['PAYPAL', 'CHECKS']
    },
    disabled: {
      type: 'object'
    },
    handleChange: {
      type: 'function',
      default: function _default() {
        return console.log("Checkbox click");
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;